@if (showSwitch) {
  <div class="persistent-flag-switch">
    <span class="persistent-flag-switch__text">{{ text() }}</span>
    <ftr-switch [value]="persistentFlagEnabled" (onValueChange)="onPersistentFlagChange($event)" />
  </div>
}
